/* tslint:disable */
/* eslint-disable */
/**
 * IbanOplata.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const AmountTypeEnum = {
    MerchantDefined: 'MerchantDefined',
    PayerDefined: 'PayerDefined'
} as const;

export type AmountTypeEnum = typeof AmountTypeEnum[keyof typeof AmountTypeEnum];



